// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__exdhQ","rootCenter":"LoadMoreObserver_rootCenter__2HH_0","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3HcQh"};